import { pathToUrl } from '../../helpers/urls';
import { ICoordinates } from '../../interfaces/geo';

export interface Boundary {
  id: number;
  area: string;
  name: string;
  rank: number;
  prohibited: number;
  prohibited_message: string;
  locales: string;
  is_top_level: number;
  freshwater: number;
  saltwater: number;
  regulation_notes: string;
}

interface Result {
  success: boolean;
  results: {
    rawBoundaries: Boundary[];
    transformedBoundaries: Boundary[];
  };
}

export async function getBoundariesAtLocation(
  { latitude, longitude }: ICoordinates,
  signal: AbortSignal,
): Promise<Result> {
  const response = await fetch(pathToUrl('/api/_fishrules/get-boundaries-at-location'), {
    body: JSON.stringify({ latitude, longitude }),
    method: 'POST',
    signal,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
  const json: Result = await response.json();
  return json;
}
